function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30",
  height: "25",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: "0"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M25.98 2.99a1 1 0 00-.11.01H20a1 1 0 100 2h3.586L13.293 15.293a1 1 0 101.414 1.414L25 6.414V10a1 1 0 102 0V4.127a1 1 0 00-1.02-1.137zM6 7c-1.093 0-2 .907-2 2v15c0 1.093.907 2 2 2h15c1.093 0 2-.907 2-2V11.422l-2 2V24H6V9h10.578l2-2H6z"
}));